import { defineStore } from 'pinia'
import api, { API_URL } from '../api'
import { t } from '../i18n'

// Older versions kept the login token here, where a script could read it. It is not used any more.
try { localStorage.removeItem('token') } catch (err) { /* private window */ }

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: JSON.parse(localStorage.getItem('user')) || null,
    loading: false,
    error: null,
  }),

  getters: {
    isAuthenticated: (state) => !!state.user,
    isVerified: (state) => state.user?.email_verified !== false,
    isPro: (state) => state.user?.tier === 'pro' || state.user?.tier === 'enterprise',
    isEnterprise: (state) => state.user?.tier === 'enterprise',
  },

  actions: {
    async signup(email, password) {
      this.loading = true
      this.error = null
      try {
        await api.post('/api/auth/signup', { email, password })       // the API answers with the cookie
        await this.fetchUser()
      } catch (err) {
        this.error = t(err.response?.data?.detail || 'Signup failed')
        throw err
      } finally {
        this.loading = false
      }
    },

    async login(email, password) {
      this.loading = true
      this.error = null
      try {
        await api.post('/api/auth/login', { email, password })
        await this.fetchUser()
      } catch (err) {
        this.error = t(err.response?.data?.detail || 'Login failed')
        throw err
      } finally {
        this.loading = false
      }
    },

    async fetchUser() {
      try {
        const response = await api.get('/api/auth/me')
        this.user = response.data
        localStorage.setItem('user', JSON.stringify(this.user))
      } catch (err) {
        this.error = t('Failed to fetch user')
        throw err
      }
    },

    async openProgram(key, example = null) {
      // The program interfaces are served by the API itself; this hands them their own cookie.
      await api.post('/api/auth/session')
      // A program opens on an empty project; `example` asks for its worked example instead.
      const query = example ? `?example=${encodeURIComponent(example)}` : ''
      window.location.href = `${API_URL}/apps/${key}/${query}`
    },

    logout() {
      api.post('/api/auth/logout').catch(() => {})
      this.user = null
      this.error = null
      localStorage.removeItem('user')
    },
  }
})
